// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/image/index.css
// module id = 210
// module chunks = 32